export default __webpack_public_path__ + "static/media/background.6eabe886.jpg";